import { useEffect } from "react";
import { useSettings } from "../context/SettingsProvider";
function TermsOfService () {
    const { settings, loading } = useSettings();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    if (loading)
    return (
      <div style={styles.loaderContainer}>
        <div style={styles.spinner}></div>
      </div>
    );

    return (
        <main className="main-content">
            <article className="blog-article-header">
                <h1 className="blog-article-title">Terms of Service</h1>
            </article>
            <div className="blog-article-content">
                <div
                    dangerouslySetInnerHTML={{ __html: settings?.terms_and_condition }}
                    style={{ marginTop: "20px", lineHeight: "1.6" }}
                />
            </div>
        </main>
    );
}

const styles = {
  loaderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "6px solid #ddd",
    borderTop: "6px solid #3498db",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
};

// Create keyframes safely
const style = document.createElement("style");
style.innerHTML = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(style);

export default TermsOfService;